import http from "../support/http";

export default {
  async finishOrder(cardUuid, body) {
    return (await http().post(`/api/v1/integration/order/finish/${cardUuid}`, body)).data;
  },
};
